var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"gradient-button hit-cursor",style:({width:_vm.width,height:_vm.height,border:_vm.border, color:_vm.color,background:_vm.background,lineHeight:_vm.height,fontSize:_vm.fontSize}),on:{"click":function($event){$event.stopPropagation();return _vm.handleClick.apply(null, arguments)}}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }